<template>
  <main class="mb-3">
<!--    banner-->
    <div class="w-100 banner-scroll-box slide carousel"  id="carouselExampleIndicators" data-bs-ride="carousel" data-bs-interval="2000">
        <div class="carousel-indicators">
          <button type="button" v-for="(b,index) of banner" :key="index"
                  data-bs-target="#carouselExampleIndicators"
                  :data-bs-slide-to="index"
                  class="active" aria-current="true"
                  aria-label="Slide 1"></button>
        </div>

      <div class="carousel-inner h-100" >
        <div class="carousel-item active h-100"
             v-for="(b,index) of banner"
             :key="index"
             :class="{ active: index === 0 }"
        >
          <img :src="b.Image" class="d-block w-100 bg-img" alt="...">
        </div>
      </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">上一页</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">下一页</span>
        </button>
    </div>
<!--    消息通知-->
    <div class="bg-white shadow-sm w-100" v-if="notice && notice.length>0">
      <div class="container-lg d-flex align-items-center justify-content-between py-2 py-sm-2 max-width-1200 w-100">
        <div class="flex-shrink-0 d-flex align-items-center">
          <img src="../assets/images/info.png" alt="" class="info-icon flex-shrink-0 me-2">
          <text class="fw-bold text-primary  me-2 me-sm-3 flex-shrink-0 d-none d-sm-block">通知公告</text>
        </div>

        <div class="message-middel" >
          <infoTipsBox :messages="notice" :path="'/noticeannouncementDetail'" ></infoTipsBox>
        </div>
        <span class="text-primary px-2 point-curser fw-bold flex-shrink-0" @click="more">更多</span>
      </div>
    </div>

    <div class="container-lg max-width-1200" >
<!--      顶部-->
      <div class="d-flex align-items-center justify-content-between p-2 flex-wrap flex-lg-nowrap" >
        <div class="sum-box sum-box1 shadow rounded-3 mt-2 d-flex align-items-center justify-content-center position-relative">
          <img src="../assets/images/device.png"  alt="" >
          <div class="ms-4 text-white">
            <h1 class="fs-3 pub-one-row">{{total_device || 0}}</h1>
            <p class=" mb-0 pub-one-row mt-1">
              设备总数
            </p>
          </div>
        </div>
        <div class="sum-box sum-box2 shadow rounded-3 mt-2 d-flex align-items-center justify-content-center position-relative">
          <img src="../assets/images/time.png"  alt="">
          <div class="ms-4 text-white">
            <h1 class="fs-3 pub-one-row">{{total_device_usage || 0}}</h1>
            <p class=" mb-0 pub-one-row mt-1">
              使用时长(小时)
            </p>
          </div>
        </div>
        <div class="sum-box sum-box3 shadow rounded-3 mt-2 d-flex align-items-center justify-content-center position-relative">
          <img src="../assets/images/supply.png"  alt="">
          <div class="ms-4 text-white">
            <h1 class="fs-3 pub-one-row ">{{total_result || 0}}</h1>
            <p class=" mb-0 pub-one-row mt-1">
              成果数
            </p>
          </div>
        </div>
        <div class="sum-box sum-box4 shadow rounded-3 mt-2 d-flex align-items-center justify-content-center position-relative">
          <img src="../assets/images/demand.png"  alt="">
          <div class="ms-4 text-white">
            <h1 class="fs-3 pub-one-row">{{total_demand || 0}}</h1>
            <p class=" mb-0 pub-one-row mt-1">
              需求数
            </p>
          </div>
        </div>
      </div>
<!--      内容-->
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 g-3">
        <!--        实验室-->
        <div class="col ">
          <FirstPageLabList :loading="loading"></FirstPageLabList>
        </div>
<!--        通知公告-->
<!--        <div class="col ">-->
<!--          <FirstPageInfoList></FirstPageInfoList>-->
<!--        </div>-->
        <!--        热门成果-->
        <div class="col">
          <FirstPageAchievementList :loading="loading"></FirstPageAchievementList>
        </div>
        <!--        最新需求-->
        <div class="col">
          <FirstPageDemandList :loading="loading"></FirstPageDemandList>
        </div>
        <!--        预约信息-->
        <div class="col">
          <FirstPageReservationList :loading="loading"></FirstPageReservationList>
        </div>
        <!--        设备状态-->
        <div class="col">
          <FirstPageDeviceStatus :loading="loading"></FirstPageDeviceStatus>
        </div>
        <!--        设备排行-->
        <div class="col">
          <FirstPageDeviceRangeList :loading="loading"></FirstPageDeviceRangeList>
        </div>
      </div>
<!--      第二行-->
      <div class="row row-cols-1 row-cols-sm-2  g-2">
<!--      设备使用时段分布  -->
        <div class="col">
          <FirstPageDeviceUseSum :loading="loading"></FirstPageDeviceUseSum>
        </div>
        <!--      设备使用趋势  -->
        <div class="col">
          <FirstPageDeviceUseTrend :loading="loading"></FirstPageDeviceUseTrend>
        </div>
      </div>
    </div>
  </main>





</template>

<script setup>
// @ is an alias to /src
import FirstPageLabList from '@/components/FirstPageLabList.vue'
import FirstPageInfoList from '@/components/FirstPageInfoList.vue'
import FirstPageAchievementList from '@/components/FirstPageAchievementList.vue'
import FirstPageDemandList from "@/components/FirstPageDemandList"
import FirstPageReservationList from "@/components/FirstPageReservationList"
import FirstPageDeviceStatus from "@/components/FirstPageDeviceStatus"
import FirstPageDeviceRangeList from "@/components/FirstPageDeviceRangeList"
import FirstPageDeviceUseSum from "@/components/FirstPageDeviceUseSum"
import FirstPageDeviceUseTrend from "@/components/FirstPageDeviceUseTrend"
import infoTipsBox from "@/components/infoTipsBox"
import router from "@/router";
import {ref, onMounted, computed} from "vue";
import {useStore} from 'vuex'
import {bgtop} from "@/utils/commonSetting";
const store = useStore()
const total_device = computed(()=> store.state.homeModel.total_device)//设备总数
const total_device_usage = computed(()=> store.state.homeModel.total_device_usage)//设备使用时长
const total_result = computed(()=> store.state.homeModel.total_result)//成果总数
const total_demand = computed(()=> store.state.homeModel.total_demand)//需求总数
const notice = computed(()=> store.state.homeModel.notice)//通知公告
const banner = ref([{
  Image:bgtop
}])
// const banner = ref([])
const loading = ref(true)

const more = () => {
  router.push({path:'/noticeannouncement'})
}
onMounted(async ()=>{
  loading.value = true
 await store.dispatch("homeModel/getHomeData") //获取用户信息
  const bList = store.getters["homeModel/getBanner"]
  if(bList.length>0){
    banner.value = bList
  }

  loading.value = false
})









</script>

<style lang="scss">
.banner-scroll-box{
  width: 100%;
  height: 30vw;
  min-height: 150px;
  max-height: 350px;
  overflow: hidden;
}
.bg-img{
  width: 100%; /* 图片宽度适配 */
  height: 100%; /* 图片高度适配 */
  object-fit: cover; /* 保持图片比例且填满容器 */
}
.sum-box{
  width: calc(50% - 10px);
  height: 80px;
  >img{
    width: 40px;
    height: 40px;
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    background: rgba(255, 255, 255, 0.3);
    //border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.5s ease, opacity 0.5s ease;
    opacity: 0;
  }
  &:hover::after {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.2;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
}


//sm
@media (min-width: 576px){
  .sum-box{
    width: calc(50% - 10px);
    height: 90px;
    >img{
      width: 45px;
      height: 45px;
    }
  }
}
// md
@media (min-width: 768px){
  .sum-box{
    width: calc(50% - 10px);
    height: 90px;
    >img{
      width: 45px;
      height: 45px;
    }
  }
}
// lg
@media (min-width: 992px){
  .sum-box{
    width: calc(25% - 10px);
    height: 90px;
    >img{
      width: 45px;
      height: 45px;
    }
  }
}
//m-xl
@media (min-width: 1200px){
  .sum-box{
    width: calc(25% - 15px);
    height: 100px;
  >img{
    width: 50px;
    height: 50px;
  }
  }
}

.badge-warning
{
  color: #fff;
  background-color: #ffbe3d;
}
.badge-pill
{
  padding-right: .875em;
  padding-left: .875em;

  border-radius: 50rem;
}


.sum-box1{
  background: linear-gradient(to right, #4998FC, #4973FC);
}
.sum-box2{
  background: linear-gradient(to right, #5AD17C, #4EB88A);
}
.sum-box3{
  background: linear-gradient(to right, #F39271, #E6614F);
}
.sum-box4{
  background: linear-gradient(to right, #8692ED, #6473E9);
}
.info-icon{
  width: 1rem;
  height: 1.2rem;
  object-fit: cover; /* 保持图片比例且填满容器 */
}
.message-box{
  width: 100%;           /* 容器宽度 */
  height: 30px;
  line-height: 30px;/* 高度 */
  overflow: hidden;      /* 隐藏超出的内容 */
  position: relative;    /* 相对定位 */
}
.message{
  display: inline-block;
  white-space: nowrap;   /* 防止文本换行 */
  animation: scrollLeft 15s linear infinite; /* 15秒水平滚动一次 */
}
@keyframes scrollLeft {
  0% {
    transform: translateX(100%); /* 从右侧开始 */
  }
  100% {
    transform: translateX(-100%); /* 滚动到左侧 */
  }
}
.message-middel{
  width: calc(100% - 60px);
}
</style>
